<template>
  <div>
    <b-form>
      <b-row>
        <!-- Field: Action -->

        <b-col
            cols="12"
            md="4"
        >
          <b-form-group
              label="Nome Tabela"
              label-for="nome_tabela"
          >
            <b-form-input
                id="nome_tabela"
                v-model="extensaoData.nome_tabela"
                @blur="onSubmit(extensaoData)"
            />
          </b-form-group>
        </b-col>

        <b-col
            cols="12"
            md="4"
        >
          <b-form-group
              label="Tabela Extensão"
              label-for="tabela_extensao"
          >
            <b-form-input
                id="tabela_extensao"
                v-model="extensaoData.tabela_extensao"
            />
          </b-form-group>
        </b-col>

      </b-row>
    </b-form>

    <b-col
        cols="12"
        md="4"
    >
      <b-button
          class="d-flex align-items-end"
          variant="primary"
          v-b-modal.modal-adicao-tb-extensao-campo
          :block="$store.getters['app/currentBreakPoint'] === 'xs'"
          @click="() => showModalAdicaoExtensaoCampos(extensaoData)"
      >
        + Campo
      </b-button>
    </b-col>
    <b-table class="mt-2" responsive="sm" :fields="tableColumns" :items="extensaoCampos">
    <template #cell(actions)="data">
      <div>
        <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="gradient-primary"
            v-b-modal.modal-edicao-tb-extensao-campo
            class="btn-icon mr-1"
            @click="showModalEdicaoExtensaoCampos(data.item)"
        >
          <feather-icon icon="EditIcon" />
        </b-button>

        <b-button
            variant="gradient-danger"
            class="btn-icon"
            @click="showModalDeleteExtensaoCampos(data.item.id)"
        >
          <feather-icon icon="TrashIcon" />
        </b-button>
      </div>
    </template>
    </b-table>
    <modal-confirmation
        v-model="isDeleteModal"
        id-modal="modal-delete-tb-extensao-campo"
        title="Deletar Campo Extensao"
        message="Tem certeza que deseja deletar?"
        btn-cancel-label="Cancelar"
        btn-ok-label="Sim"
        @ok="removeCampoExtensao"
        @cancel="isDeleteModal = false"
    />
    <b-modal
        v-if="extensaoCampoValor"
        id="modal-edicao-tb-extensao-campo"
        ok-title="Salvar"
        cancel-title="Cancelar"
        ok-variant="danger"
        modal-class="moodalClass"
        centered="centered"
        title="Edicao de Campo"
        @ok="updateCampoExtensao(extensaoCampoValor)"
        @cancel="$emit('cancel')"
    >
      <b-card-text>
        <b-col
            cols="12"
        >
          <b-form-group
              label="Nome Campo"
              label-for="tabela_extensao"
          >
            <b-form-input
                id="tabela_extensao"
                v-model="extensaoCampoValor.nome_campo"
            />
          </b-form-group>
        </b-col>
        <b-col
            cols="12"
        >
          <b-form-group
              label="Tipo"
              label-for="tabela_extensao"
          >
            <b-form-input
                id="tabela_extensao"
                v-model="extensaoCampoValor.tipo"
            />
          </b-form-group>
        </b-col>
        <b-col
            cols="12"
        >
          <b-form-group
              label="Pk"
              label-for="tabela_extensao"
          >
            <b-form-input
                id="tabela_extensao"
                v-model="extensaoCampoValor.pk"
            />
          </b-form-group>
        </b-col>
      </b-card-text>
    </b-modal>
    <b-modal
        v-if="extensaoCampoValor"
        id="modal-adicao-tb-extensao-campo"
        ok-title="Salvar"
        cancel-title="Cancelar"
        ok-variant="danger"
        modal-class="moodalClass"
        centered="centered"
        title="Adição de Campo"
        @ok="inserirCampoExtensao(extensaoCampoValor)"
        @cancel="$emit('cancel')"
    >
      <b-card-text>
        <b-col
            cols="12"
        >
          <b-form-group
              label="Nome Campo"
              label-for="tabela_extensao"
          >
            <b-form-input
                id="tabela_extensao"
                v-model="extensaoCampoValor.nome_campo"
            />
          </b-form-group>
        </b-col>
        <b-col
            cols="12"
        >
          <b-form-group
              label="Tipo"
              label-for="tabela_extensao"
          >
            <b-form-input
                id="tabela_extensao"
                v-model="extensaoCampoValor.tipo"
            />
          </b-form-group>
        </b-col>
        <b-col
            cols="12"
        >
          <b-form-group
              label="Pk"
              label-for="tabela_extensao"
          >
            <b-form-input
                id="tabela_extensao"
                v-model="extensaoCampoValor.pk"
            />
          </b-form-group>
        </b-col>
      </b-card-text>
    </b-modal>
   </div>
</template>

<script>
import RepeaterComponent from '@/components/FormRepeater.vue';
import {
  BButton,
  BMedia,
  BAvatar,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BTable,
  BCard,
  BCardHeader,
  BCardTitle,
  BFormCheckbox,
  BDropdownItem,
} from 'bootstrap-vue';
import { avatarText } from '@core/utils/filter';
import vSelect from 'vue-select';
import { useInputImageRenderer } from '@core/comp-functions/forms/form-utils';
import { ref } from '@vue/composition-api';
import store from '@/store';
import Notifier from '@/libs/Notifier';
import useExtensaoList from '@/views/app/tb-extensao/tb-extensao-list/useTbExtensaoList';
import ModalConfirmation from '@/components/ModalConfirmation.vue';
import useExtensaosList from '@/views/app/tb-extensao/tb-extensao-list/useTbExtensaoList';

export default {
  components: {
    ModalConfirmation,
    BDropdownItem,
    BButton,
    BMedia,
    BAvatar,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BTable,
    BCard,
    BCardHeader,
    BCardTitle,
    BFormCheckbox,
    vSelect,
    RepeaterComponent,
  },
  props: {
    extensaoData: {
      type: Object,
      required: true,
    },
    extensaoCampos: {
      type: Array,
      required: true,
    },

  },
  setup(props) {
    const isDeleteModal = ref(false);
    const idExtensaoCampo = ref(null);
    const extensaoCampoValor = ref(null);
    const notify = new Notifier();

    const tableColumns = [
      { key: 'nome_campo', label: 'Nome Campo', sortable: true },
      { key: 'tipo', label: 'Tipo', sortable: true },
      { key: 'pk', label: 'Chave Pk', sortable: true },
      { key: 'created_at', label: 'Criado em' },
      { key: 'actions', label: 'Ações' },
    ];
    const { resolveUserRoleVariant } = useExtensaoList();

    const roleOptions = [
      { label: 'Admin', value: 'admin' },
      { label: 'Author', value: 'author' },
      { label: 'Editor', value: 'editor' },
      { label: 'Maintainer', value: 'maintainer' },
      { label: 'Subscriber', value: 'subscriber' },
    ];

    const statusOptions = [
      { label: 'Ativo', value: 1 },
      { label: 'Inativo', value: 0 },
    ];
    const showModalDeleteExtensaoCampos = (id) => {
      idExtensaoCampo.value = id;
      isDeleteModal.value = true;
    };
    const showModalEdicaoExtensaoCampos = (item) => {
      console.log('item', item);
      extensaoCampoValor.value = item;
    };
    const showModalAdicaoExtensaoCampos = () => {
      const valorVazio = {
        nome_campo: '',
        tipo: '',
        pk: '',
      };
      extensaoCampoValor.value = valorVazio;
    };

    const tipoOptions = [
      { label: 'INSERT', value: 'INSERT' },
      { label: 'SELECT', value: 'SELECT' },
      { label: 'UPDATE', value: 'UPDATE' },
      { label: 'DELETE', value: 'DELETE' },
    ];
    // ? Demo Purpose => Update image on click of update
    const refInputEl = ref(null);
    const previewEl = ref(null);

    const { inputImageRenderer } = useInputImageRenderer(refInputEl, (base64) => {
      // eslint-disable-next-line no-param-reassign
      props.extensaoData.avatar = base64;
    });
    const removeCampoExtensao = (id) => {
      isDeleteModal.value = false;
      store.dispatch('app-extensao/removeExtensaoCampo', idExtensaoCampo.value)
        .then(() => {
          refetchData();
          notify.success('Excluido com sucesso');
        });
    };
    const updateCampoExtensao = (extensaoCampoValor) => {
      console.log(extensaoCampoValor);
      store.dispatch('app-extensao/updateExtensaoCampo', extensaoCampoValor)
        .then(() => {
          refetchData();
          notify.success('Editado com sucesso');
        });
    };
    const inserirCampoExtensao = (extensaoCampoValor) => {
      console.log(props.extensaoCampos[0].id_extensao);
      // Assuming extensaoCampoValor is an array
      // Adicione a propriedade id_extensao ao objeto extensaoCampoValor
      extensaoCampoValor.id_extensao = props.extensaoCampos[0].id_extensao;

      console.log(extensaoCampoValor);
      store.dispatch('app-extensao/inserirExtensaoCampo', extensaoCampoValor)
        .then(() => {
          refetchData();
          notify.success('Editado com sucesso');
        });
    };

    const onSubmit = (extensaoData) => {
      console.log('EXTENSAO', extensaoData);
      store.dispatch('app-extensao/putExtensao', extensaoData)
        .then(() => {
          notify.success('Extensao Alterada com sucesso');
        });
    };
    const {
      refetchData,

    } = useExtensaosList();
    return {
      isDeleteModal,
      extensaoCampoValor,
      idExtensaoCampo,
      removeCampoExtensao,
      updateCampoExtensao,
      inserirCampoExtensao,
      showModalDeleteExtensaoCampos,
      showModalEdicaoExtensaoCampos,
      showModalAdicaoExtensaoCampos,
      tableColumns,
      resolveUserRoleVariant,
      avatarText,
      onSubmit,
      roleOptions,
      tipoOptions,
      statusOptions,
      //  ? Demo - Update Image on click of update button
      refInputEl,
      previewEl,
      inputImageRenderer,
    };
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select';
</style>
